import Logs from "@/components/common/log/logs";
import Card from "@/components/ui/card";
import CardFallback from "@/components/ui/cardFallback";
import { useAuthorization } from "@/hooks/use-authorization";
import { useGetDashboardLogs } from "@/queries/dashboard/dashboard.api";
import { Permissions } from "@/utils/permissions";
import { Icon } from "@elaniintc/goes-design-system";
import { useMemo } from "react";

const DashboardLogs = () => {
  const { hasPermission } = useAuthorization();
  const hasActivity = hasPermission(Permissions.widgets.activity);

  const { data, hasNextPage, isLoading, fetchNextPage } =
    useGetDashboardLogs(hasActivity);

  const logs = useMemo(() => {
    if (!data) return [];
    const _data = data.pages.flatMap((page) => page.data);
    return (
      _data?.map(({ id, causer, created_at, description }) => {
        return {
          id,
          author:
            (
              (causer?.first_name || "") +
              " " +
              (causer?.last_name || "")
            ).trim() || "Usuario eliminado",
          date: new Date(created_at),
          action: "",
          description: description,
          causer: causer,
        };
      }) || []
    );
  }, [data]);

  return (
    <>
      {hasActivity ? (
        <Card
          data-testid="dashboard-logs"
          className="w-full h-full max-h-[450px] overflow-y-auto overflow-x-hidden self-start laptop:max-h-none @4xl:laptop:contain-size"
        >
          {data && (
            <Logs
              title="Recientemente"
              items={logs}
              fetchNextPage={fetchNextPage}
              hasNextPage={hasNextPage}
              isLoading={isLoading}
            />
          )}
          {!data && (
            <div
              data-testid="logs-loading"
              className="w-full h-full flex items-center justify-center"
            >
              <Icon
                type="far"
                name="spinner-third"
                className="text-on-disabled animate-spin text-lg"
              />
            </div>
          )}
        </Card>
      ) : (
        <CardFallback
          data-testid="dashboard-logs-fallback"
          className="w-full h-full max-h-[450px] overflow-y-auto overflow-x-hidden self-start laptop:max-h-none @4xl:laptop:contain-size flex justify-center items-center gap-4 shadow-none"
        >
          <span className="text-center font-normal text-on-disabled-quiet">
            Sin permiso para ver estos datos
          </span>
        </CardFallback>
      )}
    </>
  );
};

export default DashboardLogs;
